module.exports = __webpack_public_path__ + "assets/img/yddkz.ca0515e2.png";